var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ec71640c-b42b-4673-8ae5-3d516a0f8438",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 529.42 74.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd8a5370-a981-4bc1-bbe5-cf2d389ff279",
    x1: 449.27,
    y1: 33.64,
    x2: 529.42,
    y2: 33.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e9907a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e8907a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.81,2C498.76,2,514.93,18,514.93,37.63s-16.17,35.6-36.12,35.6S442.7,57.29,442.7,37.63,458.87,2,478.81,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.59,73.43H1.41A1.41,1.41,0,0,1,0,72V2.83a1.4,1.4,0,0,1,1.41-1.4H18.8a1.41,1.41,0,0,1,1.41,1.4V56.65H41.58A1.41,1.41,0,0,1,43,58.06V72A1.4,1.4,0,0,1,41.59,73.43Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,73.43A1.4,1.4,0,0,1,50.47,72V2.83a1.4,1.4,0,0,1,1.41-1.4h17.4a1.41,1.41,0,0,1,1.41,1.4V72a1.41,1.41,0,0,1-1.41,1.4Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.09,17.18a1.4,1.4,0,0,1-1.4,1.4h-15.8V72a1.41,1.41,0,0,1-1.41,1.4h-17.4a1.4,1.4,0,0,1-1.41-1.4V18.58h-15.8a1.41,1.41,0,0,1-1.41-1.41V2.83a1.4,1.4,0,0,1,1.41-1.4h51.82a1.4,1.4,0,0,1,1.4,1.4Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,72V2.83A1.4,1.4,0,0,1,194,1.43h42.31a1.4,1.4,0,0,1,1.4,1.4V17.2a1.4,1.4,0,0,1-1.4,1.4H212.81V28.84h20.3a1.41,1.41,0,0,1,1.41,1.41V44.62a1.41,1.41,0,0,1-1.41,1.4h-20.3V56.26h23.51a1.41,1.41,0,0,1,1.4,1.41V72a1.4,1.4,0,0,1-1.4,1.4H194A1.4,1.4,0,0,1,192.6,72Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,38.48a17.43,17.43,0,1,1-17.42,17.43A17.43,17.43,0,0,1,271.88,38.48Z",
    style: {
      fill: "#e8907a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54,3V44.75c0,13.07-7.37,28.49-30.32,28.49s-30.31-15.42-30.31-28.49V3a1.36,1.36,0,0,1,1.36-1.35h16.94A1.36,1.36,0,0,1,321.57,3V45.12c0,5.27,2.58,11.48,10.65,11.48s10.65-6.21,10.65-11.48V3a1.36,1.36,0,0,1,1.37-1.35h16.92A1.36,1.36,0,0,1,362.54,3Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.51,1.43h17.41a1.4,1.4,0,0,1,1.4,1.4V72a1.41,1.41,0,0,1-1.4,1.41h-18a1.38,1.38,0,0,1-1.22-.71l-22.58-39.9V72a1.4,1.4,0,0,1-1.41,1.4h-17.4a1.41,1.41,0,0,1-1.41-1.4V2.83a1.4,1.4,0,0,1,1.41-1.4h18a1.39,1.39,0,0,1,1.19.66l22.57,36.35V2.83A1.39,1.39,0,0,1,415.51,1.43Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.68,34.86,459.56,25a1.39,1.39,0,0,1,2,0l15.12,15.11L514.71,2a1.42,1.42,0,0,1,2,0L529,14.34a1.38,1.38,0,0,1,0,2L480.08,65.25a1.41,1.41,0,0,1-2,0L449.68,36.84A1.39,1.39,0,0,1,449.68,34.86Z",
    style: {
      fill: "url(#bd8a5370-a981-4bc1-bbe5-cf2d389ff279)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,16.46a1.39,1.39,0,0,1-1.68,1.24,74.49,74.49,0,0,0-13.15-1.65c-7.13-.12-8.06,4.45-8.06,5.73s.81,6.07,9.35,8.18a23.63,23.63,0,0,1,18.11,23.49c0,13.68-7.82,20.67-27.46,20.67a125.44,125.44,0,0,1-15.24-.9A1.39,1.39,0,0,1,85,71.7l1.35-14a1.4,1.4,0,0,1,1.7-1.24,67,67,0,0,0,12.72,1.62c7.13.12,8.06-4.44,8.06-5.72s-.81-6.08-9.35-8.18A23.65,23.65,0,0,1,81.37,20.67C81.37,7,92,0,108.83,0c6.16,0,12.82.63,15.63.92a1.41,1.41,0,0,1,1.24,1.53Z",
    style: {
      fill: "#1d1d1b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logo-large.58b2de820e862e03d42f74a3b1c189fe.svg";
export { ForwardRef as ReactComponent };